export default __webpack_public_path__ + "static/customwrittenpapers-b1c9ed6a81bc58450c536012f3f36d82.webp";